import React, { useState } from "react";
import productDefault from "../../assets/png/product_default.png";
import profileIc from "../../assets/png/profile-ic.png";
import ProfileImageModal from "../common/common-preview";

const PurchaseRequestTab = ({
  vendorHistoryList,
  hoveredIndex,
  setHoveredIndex,
}) => {
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  return (
    <>
      <ProfileImageModal
        show={showProfilePopup}
        onClose={() => setShowProfilePopup(false)}
        imageUrl={selectedProfile}
      />
      <div
        style={{
          display: "flex",
          flex: "10",
          paddingLeft: "16px",
          paddingRight: "16px",
          paddingTop: "16px",
          height: "40px",
          backgroundColor: "#F2F2F2",
        }}
        className="head3 w-100 justify-content-center align-items-center"
      >
        <p
          style={{ width: "127px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Request ID
        </p>
        <p
          style={{ width: "160px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Product
        </p>
        <p
          style={{ width: "160px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Vendor
        </p>{" "}
        <p
          style={{ width: "160px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Qty
        </p>{" "}
        <p
          style={{ width: "160px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Exp. delivery date
        </p>{" "}
        <p
          style={{ width: "160px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Status
        </p>{" "}
      </div>
      <div>
        {(vendorHistoryList ?? []).map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              flex: "10",
              paddingLeft: "16px",
              paddingRight: "16px",
              backgroundColor: hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
              borderBottom: "1px solid #D4DDE7",
              cursor: "pointer",
              height: "44px",
            }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            className="head3 w-100 justify-content-center align-items-center"
          >
            {" "}
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.req_no ?? ""}
            >
              {item.req_no ?? "---"}
            </p>
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.part ?? "---"}
            >
              <img
                key={index}
                src={
                  item.product_image && item.product_image.trim() !== ""
                    ? item.product_image
                    : productDefault
                }
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedProfile(
                    item.product_image && item.product_image.trim() !== ""
                      ? item.product_image
                      : productDefault,
                  );
                  setShowProfilePopup(true);
                }}
                alt="Profile"
                className="avatar-item me-1 ms-0"
              />
              {item.part ?? "---"}
            </p>
            <div
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
              title={item.vendor_name}
            >
              {" "}
              <img
                key={index}
                src={
                  item.image && item.image.trim() !== ""
                    ? item.image
                    : profileIc
                }
                alt="Profile"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedProfile(
                    item.image && item.image.trim() !== ""
                      ? item.image
                      : profileIc,
                  );
                  setShowProfilePopup(true);
                }}
                className="avatar-item me-1 ms-0"
              />
              {item.vendor_name ?? "---"}
            </div>
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.qty}
            >
              {item.qty ?? "---"}
            </p>
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.expected_delivery_date}
            >
              {item.expected_delivery_date ?? "---"}
            </p>
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.status ?? ""}
            >
              <span
                className="backgroundYellow mx-2"
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "3px",
                  display: "inline-block",
                }}
              ></span>{" "}
              {item.status ?? "---"}
            </p>
          </div>
        ))}
      </div>
    </>
  );
};

export default PurchaseRequestTab;
